import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

interface AlertProps {
  type: 'info' | 'warning' | 'success' | 'error'
  title?: string
  children: React.ReactNode
}

const alertStyles = {
  info: {
    bgcolor: '#EFF6FF',
    borderColor: '#3B82F6',
    iconColor: '#3B82F6',
    Icon: InfoOutlinedIcon,
  },
  warning: {
    bgcolor: '#FFFBEB',
    borderColor: '#F59E0B',
    iconColor: '#F59E0B',
    Icon: WarningAmberOutlinedIcon,
  },
  success: {
    bgcolor: '#F0FDF4',
    borderColor: '#22C55E',
    iconColor: '#22C55E',
    Icon: CheckCircleOutlineIcon,
  },
  error: {
    bgcolor: '#FEF2F2',
    borderColor: '#EF4444',
    iconColor: '#EF4444',
    Icon: ErrorOutlineIcon,
  },
}

export default function Alert({ type, title, children }: AlertProps) {
  const style = alertStyles[type]
  const IconComponent = style.Icon

  return (
    <Box
      sx={{
        bgcolor: style.bgcolor,
        borderLeft: '4px solid',
        borderColor: style.borderColor,
        borderRadius: 1,
        p: 2,
        my: 3,
        display: 'flex',
        gap: 2,
      }}
    >
      <IconComponent sx={{ color: style.iconColor, mt: 0.25 }} />
      <Box>
        {title && (
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, mb: 0.5, color: 'text.primary' }}
          >
            {title}
          </Typography>
        )}
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {children}
        </Typography>
      </Box>
    </Box>
  )
}
